<nb-card class="linked-products-dialog" style="min-width: 500px; max-width: 700px; max-height: 80vh; overflow-y: auto;">
  <nb-card-header>
    <div class="header-row">
      <h4>Linked Store Products</h4>
      <small *ngIf="globalProduct">for: <strong>{{ globalProduct.name }}</strong></small>
    </div>
  </nb-card-header>

  <nb-card-body>
    <div class="loading-state" *ngIf="loading">
      <p>Loading linked products…</p>
    </div>

    <div class="empty-state" *ngIf="!loading && linkedProducts.length === 0">
      <nb-icon icon="link-2-outline" style="font-size: 2rem; color: #bdbdbd;"></nb-icon>
      <p>No store products are linked to this global product yet.</p>
    </div>

    <table class="linked-table" *ngIf="!loading && linkedProducts.length > 0">
      <thead>
        <tr>
          <th>Store</th>
          <th>Product Name</th>
          <th>Field Locks</th>
          <th>Sync Status</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let lp of linkedProducts">
          <td>{{ lp.storeId?.storeName || lp.storeId?.name || lp.storeName || lp.storeId?._id || lp.storeId || '—' }}</td>
          <td>{{ lp.productName || lp.name || '—' }}</td>
          <td>
            <span class="lock-chip" [ngClass]="getLockedFieldsCount(lp) > 0 ? 'locks-active' : 'no-locks'">
              <nb-icon [icon]="getLockedFieldsCount(lp) > 0 ? 'lock-outline' : 'unlock-outline'" style="font-size: 14px; margin-right: 4px;"></nb-icon>
              {{ getLockedFieldsCount(lp) }} locked
            </span>
          </td>
          <td>
            <span class="sync-chip" [ngClass]="getLockedFieldsCount(lp) > 0 ? 'overrides-active' : 'synced'">
              {{ getLockedFieldsCount(lp) > 0 ? 'Overrides active' : 'Synced' }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </nb-card-body>

  <nb-card-footer style="display: flex; justify-content: flex-end; padding: 12px 20px;">
    <button class="btn btn-outline-secondary" type="button" (click)="close()">Close</button>
  </nb-card-footer>
</nb-card>
